const IconFilter = ({ className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#icon-filter-clip)">
                <path d="M16.6673 3.33374H3.33398V5.18957C3.33403 5.60407 3.48852 6.00368 3.76732 6.31041L7.50065 10.4171V17.5004L12.5007 15.8337V10.0004L16.179 6.32207C16.4916 6.00959 16.6672 5.58573 16.6673 5.14374V3.33374Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="icon-filter-clip">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconFilter;
